import { DeletedModel, isDeletedModel } from 'modules/sockets';

export default function updateModelList<
  T extends { id: string },
  U extends { id: string }
>(
  list: T[],
  update: U | DeletedModel,
  applyUpdate: (update: U, existing?: T) => T,
): T[] {
  if (isDeletedModel(update)) {
    return list.filter((entry) => entry.id !== update.id);
  } else if (list.some((entry) => entry.id === update.id)) {
    return list.map(
      (entry) => (entry.id === update.id ? applyUpdate(update, entry) : entry),
    );
  } else {
    return [...list, applyUpdate(update)];
  }
}



// WEBPACK FOOTER //
// ./app/gamma/src/modules/state/models/util/updateModelList.ts